export default __webpack_public_path__ + "static/media/winline_loyalty_3.f334e516.png";